import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PoLookupFilter, PoLookupFilteredItemsParams, PoNotificationService } from '@po-ui/ng-components';
import { ContextApplication } from 'src/app/Context/contextapplication/contextapplication';
import { UrlServerApiUtils } from 'src/utils/server-api-utils';

@Injectable({ providedIn: 'root' })
export class InputLookupService implements PoLookupFilter {

  constructor(
    private httpClient: HttpClient,
    private contextApplication: ContextApplication,
    private poNotification: PoNotificationService
  ) {
    this.poNotification.setDefaultDuration(10000);
  }

  private urlWithText = '';
  public IsSearching = false;
  serverApiUtils = new UrlServerApiUtils(this.contextApplication);

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    this.urlWithText = this.getUrlApiInput();
    if (filteredParams.filter) {
      this.urlWithText += `&$filter=startswith(description ,'${filteredParams.filter}') or startswith(inputCode ,'${filteredParams.filter}')`;
    }
    const { page, pageSize } = filteredParams;
    const parameters = { page: page.toString(), pageSize: pageSize.toString() };

    return this.httpClient
      .get(this.urlWithText, { params: parameters, headers: this.serverApiUtils.getHeaderOptions() })
      .pipe(
        catchError((error) => {
          this.poNotification.warning(error["error"].DetailMessage);
          return error;
        })
      );
  }

  getObjectByValue(value: string): Observable<any> {
    this.IsSearching = true;
    this.urlWithText = this.getUrlApiInput();
    if (value) {
      this.urlWithText += `&$filter=startswith(description ,'${value}') or startswith(inputCode ,'${value}')`;
    }
    return this.httpClient
      .get(this.urlWithText, { headers: this.serverApiUtils.getHeaderOptions() })
      .pipe(
        catchError((error) => {
          this.poNotification.warning(error["error"].DetailMessage);
          return error;
        })
      );
  }

  getUrlApiInput(): string {
    return this.contextApplication.Server.apiServer + '/api/construction-projects/v2/inputs?' + this.contextApplication.Filter;
  }
}
